import Contact from "../pages/institutional/Contact";
import About from "../pages/institutional/About";
import { lazy, Suspense } from 'react';
const AffiliateAdmin = lazy(() => import('../pages/institutional/AffiliateAdminPortal'));
import Affiliates from "../pages/institutional/Affiliates";
import OrderLookup from "../pages/institutional/OrderLookup";
import Exchanges from "../pages/institutional/Exchanges";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Landing from "../pages/home/landing";
import ProductDetailPage from "../pages/product/page";

const routes: RouteObject[] = [
  {path:'/admin/afiliados', element:<Suspense fallback={<div role="status">Carregando administração…</div>}><AffiliateAdmin /></Suspense>},
  {path:"/afiliados", element:<Affiliates />},
  {path:"/meus-pedidos", element:<OrderLookup />},
  {path:"/contato", element:<Contact />},
  {path:"/sobre", element:<About />},
  {path:"/politica-de-trocas", element:<Exchanges />},
  {path:"/trocas-e-devolucoes", element:<Exchanges />},
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: "/produtos",
    element: <Home />,
  },
  {
    path: "/produto/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
